import { IntegrationsSyncContextProvider } from 'modules/integrations/public'
import { LEAVE_CHANGE_TYPES } from 'modules/payroll_bundle/lib/Incidences/Types'
import { EMPLOYEE_UPDATES_LEAVE_SYNC_CONFIGURATION } from './SyncConfiguration'

import LeaveSyncBanner from './LeaveSyncBanner'

interface Incidence {
  id: string
  name: string
  targetId: string
}

interface SyncBannerProps {
  incidence: Incidence
}

const isLeaveIncidence = (name: string) => Object.values(LEAVE_CHANGE_TYPES).includes(name)

const SyncBanner = ({ incidence }: SyncBannerProps) => {
  if (isLeaveIncidence(incidence.name)) {
    return (
      <IntegrationsSyncContextProvider configuration={EMPLOYEE_UPDATES_LEAVE_SYNC_CONFIGURATION}>
        <LeaveSyncBanner incidenceId={incidence.id} leaveId={incidence.targetId} />
      </IntegrationsSyncContextProvider>
    )
  }

  return null
}

export default SyncBanner
